import { useSyncExternalStore } from 'react';

const emptySubscribe = () => () => {};

export const useIsMounted = (): boolean =>
  useSyncExternalStore(
    emptySubscribe,
    () => true,
    () => false,
  );
